import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './global-components/navbar-v2';
import Banner from './section-components/banner-v2';
import Intro from './section-components/intro-v2';
import About from './section-components/about-v2';
import Client from './section-components/client';
import HowToWork from './section-components/how-to-work';
import Temoignages from './section-components/temoignages';
import PageHeader2 from './global-components/page-header2';
import Footer from './global-components/footer-v2';
import Scrollp from './Scroll-Parallax/scrollp';
import { motion } from 'framer-motion';
import './home_v2.css';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0, // pas de délai entre les enfants
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut',
    },
  },
};

const Home_V2 = () => {
  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    html.style.overflow = 'hidden';
    body.style.overflow = 'hidden';
    window.scrollTo(0, 0);
    html.scrollTop = 0;
    body.scrollTop = 0;
    const timer = setTimeout(() => {
      html.style.overflow = '';
      body.style.overflow = '';
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  const sections = [
    { component: Intro },
    { component: About },
    { component: Temoignages },
    { component: Client },
    { component: HowToWork },
    { component: PageHeader2 },
    { component: Footer },
    { component: Scrollp },
  ];

  return (
    <div className="page-container">
      <Navbar />
      <Banner />

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {sections.map(({ component: Component }, idx) => (
          <motion.div key={idx} variants={itemVariants}>
            <Component />
          </motion.div>
        ))}
      </motion.div>

      <div className="fixed-buttons">
        <Link to="/Formateur">
          <button className="btn btn-primary">Devenir formateur</button>
        </Link>
        <Link to="/inscriptionenligne">
          <button className="btn btn-secondary">Inscription en ligne</button>
        </Link>
      </div>
    </div>
  );
};

export default Home_V2;
